module.exports = __webpack_public_path__ + "static/BS-389fc91e505b8c9c204155bb3f2fea21.png";